import { PageLayout } from '@components/PageLayout/PageLayout';
import { NextPage } from 'next';
import cn from 'classnames';
import { WillBeSoon } from '@components/WillBeSoon/WillBeSoon';
interface PageProps {}
const Page: NextPage<PageProps> = () => {
  return <PageLayout data-sentry-element="PageLayout" data-sentry-component="Page" data-sentry-source-file="faq.tsx">
            <div className={cn('_container')}>
                <WillBeSoon data-sentry-element="WillBeSoon" data-sentry-source-file="faq.tsx" />
            </div>
        </PageLayout>;
};
export default Page;